import { currentUserVar } from 'apollo/reactive-variables/user';
import { DEFAULT_LOCALE_FORMAT, LocaleFormat, LocaleLanguage } from 'models/locale-format';

export const getCurrentLocaleFormat = (): LocaleFormat => {
    const user = currentUserVar();
    const stored = user?.localeFormat;
    if (!stored) return DEFAULT_LOCALE_FORMAT;
    return {
        language: stored.language ?? DEFAULT_LOCALE_FORMAT.language,
        date: stored.date ?? DEFAULT_LOCALE_FORMAT.date,
        number: stored.number ?? DEFAULT_LOCALE_FORMAT.number,
    };
};

// ISO 639-1 short code (e.g. `en`, `sv`) derived from the BCP47 language.
// Used by external integrations (Google geocoder, Unifaun tracking URLs) that
// expect 2-letter language codes rather than the full BCP47 form.
export const getShortLanguageCode = (language?: LocaleLanguage): string => {
    return (language ?? DEFAULT_LOCALE_FORMAT.language).split('_')[0];
};
